export default "__VITE_ASSET__1341a1b6__"